import { ProductOfferAction } from '../actions/ProductOfferAction'

const initState = {
    productOfferingPrice: '',
    productCharecteristics: '',
    getProductOffer: ''
}

const ProductOfferReducer = (state: any = initState, action: any) => {
    const { type } = action;
    const { payload } = action;

    switch (type) {
        case ProductOfferAction.LOAD_PRODUCT_OFFER_SUCCESS:
           
            return { ...state, productOfferingPrice: payload.response?.data?.getProductOfferByID?.[0]?.productOfferingPrice,
                            productCharecteristics: payload.response?.data?.getProductOfferByID?.[0]?.specCharValueUse,
                            getProductOffer: payload.response?.data?.getProductOfferByID?.[0] }

        default:
            return state;
    }
}

export default ProductOfferReducer;